import { render, staticRenderFns } from "./LikeCounter.vue?vue&type=template&id=6a925790&"
import script from "./LikeCounter.vue?vue&type=script&lang=ts&"
export * from "./LikeCounter.vue?vue&type=script&lang=ts&"
import style0 from "./LikeCounter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
